/* PLATONIC — chrome interactions (header · nav overlay · back-to-top).
   Ported from the prototype app.js. Cart-drawer behaviour is intentionally
   deferred — the header/menu cart buttons route to the cart page for now and
   will be wired to the slide-out drawer in a later milestone. */

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initNavDrawer();
  initToTop();
  initFragranceDropdown();
  initReducedMotion();
});

/* Respect prefers-reduced-motion: pause autoplaying videos (they show their poster
   instead). WCAG 2.2.2 — continuous auto-motion >5s must be stoppable. */
function initReducedMotion() {
  if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('video[autoplay]').forEach((v) => {
    try { v.removeAttribute('autoplay'); v.pause(); } catch (e) {}
  });
}

/* Header turns solid after a short scroll. */
function initHeader() {
  const header = document.querySelector('.header');
  if (!header) return;
  const update = () => {
    header.classList.toggle('is-solid', window.scrollY > 64);
  };
  update();
  window.addEventListener('scroll', update, { passive: true });
}

/* Full-screen nav overlay open/close (mobile menu). */
function initNavDrawer() {
  const overlay = document.querySelector('.nav-overlay');
  if (!overlay) return;
  let lastFocus = null;

  // The page behind the open dialog — hidden from screen readers + pointer/Tab
  // so assistive tech can't wander out of the modal mid-navigation.
  const bgEls = ['#MainContent', 'header.header', 'footer.footer']
    .map((s) => document.querySelector(s)).filter(Boolean);
  const setBgInert = (on) => bgEls.forEach((el) => { el.inert = on; });

  const focusables = () => Array.prototype.slice.call(overlay.querySelectorAll(
    'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
  )).filter((el) => el.offsetParent !== null);

  const open = () => {
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-nav-open]').forEach((t) => t.setAttribute('aria-expanded', 'true'));
    document.body.style.overflow = 'hidden';
    setBgInert(true);
    // Focus the dialog container (not the first link/logo) so touch users don't
    // get a focus box drawn around the brand mark. Tab still moves into the menu,
    // and screen readers announce the modal (aria-modal + aria-label).
    overlay.focus();
  };
  const close = () => {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-nav-open]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
    document.body.style.overflow = '';
    setBgInert(false); // lift inert BEFORE restoring focus — the toggle lives in the header
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  document.querySelectorAll('[data-nav-open]').forEach((t) =>
    t.addEventListener('click', (e) => { e.preventDefault(); open(); })
  );
  document.querySelectorAll('[data-nav-close]').forEach((c) =>
    c.addEventListener('click', close)
  );
  document.addEventListener('keydown', (e) => {
    if (!overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      const f = focusables();
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
}

/* Back-to-top — reveal after ~0.6 viewport of scroll, smooth-scroll up. */
function initToTop() {
  const btn = document.querySelector('[data-to-top]');
  if (!btn) return;
  const onScroll = () => btn.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.6);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }));
}

/* FRAGRANCES dropdown — keep aria-expanded in sync with the CSS hover/focus
   open state (assistive-tech support; the dropdown itself opens via CSS). */
function initFragranceDropdown() {
  const group = document.querySelector('[data-nav-group]');
  const trigger = group && group.querySelector('.header-nav-trigger');
  if (!group || !trigger) return;
  const set = (open) => trigger.setAttribute('aria-expanded', String(open));
  set(false);
  group.addEventListener('mouseenter', () => set(true));
  group.addEventListener('mouseleave', () => set(false));
  group.addEventListener('focusin', () => set(true));
  group.addEventListener('focusout', () => set(false));
}

/* Cart icon → slide-out drawer is handled by platonic-cart.js
   (window.PlatonicCart). No cart-page navigation here. */
